/**
 * Frontend: search, filter, layout toggle, sortable table, modal / subpage detail.
 */
document.querySelectorAll( '.br-pub' ).forEach( ( block ) => {
	const search     = block.querySelector( '[data-br-pub-search]' );
	const dropdown   = block.querySelector( '[data-br-pub-dropdown]' );
	const countEl    = block.querySelector( '[data-br-pub-count]' );
	const toggleWrap = block.querySelector( '[data-br-pub-layout-toggle]' );
	const modal      = block.querySelector( '[data-br-pub-modal]' );
	const subpage    = block.querySelector( '[data-br-pub-subpage]' );
	const restUrl    = block.dataset.restUrl || '';
	const nonce      = block.dataset.nonce || '';
	const detailView = block.dataset.detailView || 'subpage';

	let currentLayout = block.dataset.defaultLayout || 'cards';
	let activeSector  = 'all';
	let searchQuery   = '';

	let currentListPage       = 0;
	let renderListPagination  = () => {};

	/* ─── Listing elements (hidden when subpage is open) ─── */
	const listingEls = () => [
		block.querySelector( '.br-pub__heading' ),
		block.querySelector( '.br-pub__toolbar' ),
		block.querySelector( '[data-br-pub-content="table"]' ),
		block.querySelector( '[data-br-pub-content="cards"]' ),
		block.querySelector( '[data-br-pub-content="list"]' ),
		block.querySelector( '[data-br-pub-list-pager]' ),
		block.querySelector( '[data-br-pub-count]' ),
		block.querySelector( '.br-pub__empty' ),
	].filter( Boolean );

	/* ─── Filter helpers ─── */
	const getItems = ( lay ) => lay === 'table'
		? [ ...block.querySelectorAll( '.br-pub__table tbody tr' ) ]
		: [ ...block.querySelectorAll( '.br-pub__card' ) ];

	const applyFilters = () => {
		[ 'table', 'cards' ].forEach( ( lay ) => {
			const q = searchQuery.toLowerCase().trim();
			let visible = 0;
			getItems( lay ).forEach( ( el ) => {
				const sector = ( el.dataset.sector || '' ).toLowerCase();
				const text   = el.textContent.toLowerCase();
				const show   = ( activeSector === 'all' || sector === activeSector.toLowerCase() ) && ( ! q || text.includes( q ) );
				el.style.display = show ? '' : 'none';
				if ( show ) visible++;
			} );
			if ( lay === currentLayout && countEl ) countEl.textContent = `${ visible } publication(s)`;
		} );
		if ( currentLayout === 'list' ) {
			currentListPage = 0;
			renderListPagination();
		}
	};

	/* ─── Search ─── */
	if ( search ) {
		let t;
		search.addEventListener( 'input', ( e ) => { clearTimeout( t ); t = setTimeout( () => { searchQuery = e.target.value; applyFilters(); }, 200 ); } );
	}

	/* ─── Dropdown ─── */
	if ( dropdown ) {
		const tog = dropdown.querySelector( '[data-br-pub-dropdown-toggle]' );
		const menu = dropdown.querySelector( '[data-br-pub-dropdown-menu]' );
		tog.addEventListener( 'click', () => {
			const open = dropdown.classList.toggle( 'is-open' );
			if ( open ) setTimeout( () => {
				const fn = ( e ) => { if ( ! dropdown.contains( e.target ) ) { dropdown.classList.remove( 'is-open' ); document.removeEventListener( 'click', fn ); } };
				document.addEventListener( 'click', fn );
			}, 0 );
		} );
		menu.addEventListener( 'click', ( e ) => {
			const it = e.target.closest( '[data-sector]' ); if ( ! it ) return;
			menu.querySelectorAll( '.br-pub__dropdown-item' ).forEach( ( i ) => i.classList.remove( 'is-active' ) );
			it.classList.add( 'is-active' );
			activeSector = it.dataset.sector;
			tog.querySelector( 'span' ).textContent = activeSector === 'all' ? 'Filter by' : activeSector;
			dropdown.classList.remove( 'is-open' ); applyFilters();
		} );
	}

	/* ─── Layout toggle ─── */
	if ( toggleWrap ) {
		toggleWrap.addEventListener( 'click', ( e ) => {
			const btn = e.target.closest( '[data-layout]' ); if ( ! btn ) return;
			const nl = btn.dataset.layout; if ( nl === currentLayout ) return;
			toggleWrap.querySelectorAll( '.br-pub__toggle-btn' ).forEach( ( b ) => b.classList.remove( 'is-active' ) );
			btn.classList.add( 'is-active' );
			block.querySelector( `[data-br-pub-content="${ currentLayout }"]` ).style.display = 'none';
			block.querySelector( `[data-br-pub-content="${ nl }"]` ).style.display = '';
			currentLayout = nl;
			applyFilters();
			if ( nl === 'list' ) renderListPagination();
		} );
	}

	/* ─── Compact list pagination ─── */
	const listEl      = block.querySelector( '[data-br-pub-content="list"]' );
	const listPagerEl = block.querySelector( '[data-br-pub-list-pager]' );

	if ( listEl && listPagerEl ) {
		const perPage = parseInt( listEl.dataset.listPerPage, 10 ) || 10;

		const getFilteredListItems = () => {
			const q = searchQuery.toLowerCase().trim();
			return [ ...listEl.querySelectorAll( '.br-pub__list-item' ) ].filter( ( el ) => {
				const sector = ( el.dataset.sector || '' ).toLowerCase();
				const text   = ( el.dataset.pubTitle || '' ).toLowerCase();
				return ( activeSector === 'all' || sector === activeSector.toLowerCase() )
					&& ( ! q || text.includes( q ) );
			} );
		};

		renderListPagination = () => {
			const all     = [ ...listEl.querySelectorAll( '.br-pub__list-item' ) ];
			const visible = getFilteredListItems();
			const total   = Math.ceil( visible.length / perPage );

			if ( currentListPage >= total ) currentListPage = Math.max( 0, total - 1 );

			const pageSet = new Set(
				visible.slice( currentListPage * perPage, ( currentListPage + 1 ) * perPage )
			);
			all.forEach( ( el ) => { el.hidden = ! pageSet.has( el ); } );

			if ( countEl ) countEl.textContent = `${ visible.length } publication(s)`;

			if ( total <= 1 ) { listPagerEl.hidden = true; return; }
			listPagerEl.hidden = false;

			let html = '';
			for ( let i = 0; i < total; i++ ) {
				html += `<button class="br-pub__list-page-btn${ i === currentListPage ? ' is-active' : '' }" data-page="${ i }">${ i + 1 }</button>`;
			}
			listPagerEl.innerHTML = html;
		};

		listPagerEl.addEventListener( 'click', ( e ) => {
			const btn = e.target.closest( '[data-page]' ); if ( ! btn ) return;
			currentListPage = parseInt( btn.dataset.page, 10 );
			renderListPagination();
		} );

		if ( currentLayout === 'list' ) renderListPagination();
	}

	/* ─── Table sort ─── */
	const tableEl = block.querySelector( '.br-pub__table' );
	if ( tableEl ) {
		let sCol = 'date', sDir = 'desc';
		const val = ( r, c ) => ( { title: r.dataset.pubTitle, sector: r.dataset.pubSector, type: r.dataset.pubType, date: r.dataset.pubDate }[ c ] || '' );
		const doSort = () => {
			const tb = tableEl.querySelector( 'tbody' ), rows = [ ...tb.querySelectorAll( 'tr' ) ];
			rows.sort( ( a, b ) => { let c = val( a, sCol ).toLowerCase().localeCompare( val( b, sCol ).toLowerCase() ); return sDir === 'desc' ? -c : c; } );
			rows.forEach( r => tb.appendChild( r ) );
			tableEl.querySelectorAll( '.br-pub__th-sort' ).forEach( th => {
				th.classList.remove( 'is-active-asc', 'is-active-desc' );
				if ( th.dataset.sort === sCol ) th.classList.add( sDir === 'asc' ? 'is-active-asc' : 'is-active-desc' );
			} );
		};
		tableEl.querySelector( 'thead' ).addEventListener( 'click', ( e ) => {
			const th = e.target.closest( '[data-sort]' ); if ( ! th ) return;
			const c = th.dataset.sort;
			if ( c === sCol ) sDir = sDir === 'asc' ? 'desc' : 'asc'; else { sCol = c; sDir = c === 'date' ? 'desc' : 'asc'; }
			doSort();
		} );
	}

	/* ═══════════════════════════════════════
	   SHARED: Fetch detail + render helpers
	   ═══════════════════════════════════════ */

	const LANG_LABELS = { E: 'English', F: 'Français', S: 'Español', A: 'العربية', C: '中文', R: 'Русский' };

	/* ─── Language detection from URL hash ─── */
	const HASH_TO_LABEL = { fr: 'Français', ar: 'العربية', zh: '中文', ru: 'Русский', es: 'Español', en: 'English' };

	const getPageLangLabel = () => {
		const hash = window.location.hash; // e.g. "#/fr"
		const match = hash.match( /^#\/?([a-z]{2})/ );
		return match ? ( HASH_TO_LABEL[ match[ 1 ] ] || 'English' ) : 'English';
	};

	/** Resolve the display label for a download item */
	const getDlLabel = ( dl ) => {
		return dl.lang && LANG_LABELS[ dl.lang ] ? LANG_LABELS[ dl.lang ] : ( dl.label || 'Document' );
	};

	/* ─── Previewable file types ─── */
	const PREVIEWABLE = new Set( [ 'pdf', 'htm', 'html', 'doc', 'docx' ] );
	const PREVIEW_PRIORITY = { pdf: 0, doc: 1, docx: 1, htm: 2, html: 2 };

	const canPreview = ( dl ) => PREVIEWABLE.has( detectFileType( dl ) );

	/**
	 * Pick the best file to preview from a list, respecting:
	 *   1. Page language label (e.g. "Français") or fallback to "English"
	 *   2. File type priority: PDF → DOC/DOCX → HTM/HTML
	 */
	const pickBestPreview = ( downloads ) => {
		const targetLabel = getPageLangLabel();
		const previewable = ( downloads || [] ).filter( canPreview );
		if ( ! previewable.length ) return null;

		// Sort by priority (pdf first, htm last)
		const sorted = [ ...previewable ].sort( ( a, b ) =>
			( PREVIEW_PRIORITY[ detectFileType( a ) ] ?? 9 ) - ( PREVIEW_PRIORITY[ detectFileType( b ) ] ?? 9 )
		);

		// Best match: right language label + best type, fallback English, then first
		return sorted.find( dl => getDlLabel( dl ) === targetLabel )
			|| sorted.find( dl => getDlLabel( dl ) === 'English' )
			|| sorted[ 0 ];
	};

	/**
	 * Build the iframe src for a given download item.
	 * - PDF  → direct URL + zoom hash
	 * - HTM/HTML → direct URL
	 * - DOC/DOCX → Office Online viewer
	 */
	const buildPreviewSrc = ( url, ext, zoom ) => {
		if ( ext === 'pdf' ) {
			return `${ url }#toolbar=0&navpanes=0&zoom=${ zoom }`;
		}
		if ( ext === 'htm' || ext === 'html' ) {
			return url;
		}
		if ( ext === 'doc' || ext === 'docx' ) {
			return `https://view.officeapps.live.com/op/embed.aspx?src=${ encodeURIComponent( url ) }`;
		}
		return url;
	};

	const fetchDetail = ( link ) => {
		if ( ! restUrl || ! link ) return Promise.reject();
		return fetch( `${ restUrl }?url=${ encodeURIComponent( link ) }`, { headers: { 'X-WP-Nonce': nonce } } )
			.then( r => r.json() );
	};

	const detectFileType = ( dl ) => {
		const url = ( dl.url || '' ).toLowerCase();
		const label = ( dl.label || '' ).toLowerCase();

		const pathMatch = url.match( /\.([a-z0-9]{2,5})(?:[?#]|$)/i );
		if ( pathMatch ) {
			const ext = pathMatch[ 1 ];
			if ( [ 'pdf', 'zip', 'rar', '7z', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'csv', 'txt', 'xml', 'epub', 'mobi', 'htm', 'html' ].includes( ext ) ) return ext;
		}

		const formatMatch = url.match( /[?&](?:format|type|ext|filetype)=([a-z0-9]+)/i );
		if ( formatMatch ) return formatMatch[ 1 ];

		if ( /\.pdf|\/pdf|pdf$/i.test( label ) || /\.pdf|\/pdf/i.test( url ) ) return 'pdf';
		if ( /\.zip|\/zip|zip$/i.test( label ) || /\.zip|\/zip/i.test( url ) ) return 'zip';
		if ( /\.docx?\b/i.test( label ) || /\/docx?\b/i.test( url ) ) return 'docx';
		if ( /\.xlsx?\b/i.test( label ) || /\/xlsx?\b/i.test( url ) ) return 'xlsx';
		if ( /\.pptx?\b/i.test( label ) || /\/pptx?\b/i.test( url ) ) return 'pptx';

		if ( /table of contents|toc|summary/i.test( label ) ) return 'pdf';
		if ( /archive|compressed/i.test( label ) ) return 'zip';
		if ( /spread|data/i.test( label ) ) return 'xlsx';
		if ( /presentation|slide/i.test( label ) ) return 'pptx';

		return 'pdf';
	};

	const LANG_COLORS = {
		E: '#0076a1', F: '#2b71b1', S: '#d4a017', A: '#217346', C: '#c0392b', R: '#8e44ad',
	};

	const FILE_TYPE_COLORS = {
		pdf: '#c0392b', zip: '#f39c12', rar: '#f39c12', '7z': '#f39c12',
		doc: '#2b71b1', docx: '#2b71b1', xls: '#217346', xlsx: '#217346',
		csv: '#217346', ppt: '#d24726', pptx: '#d24726', epub: '#8e44ad',
		mobi: '#e67e22', htm: '#e44d26', html: '#e44d26',
	};

	const LANG_ICON_LABELS = { E: 'EN', F: 'FR', S: 'ES', A: 'AR', C: 'ZH', R: 'RU' };

	const DOC_SVG_WITH_LABEL = ( label, color ) =>
		`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28" fill="none" stroke-width="1.5">
			<path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="${ color }"/>
			<polyline points="14 2 14 8 20 8" stroke="${ color }"/>
			<text x="12" y="17.5" text-anchor="middle" font-size="${ label.length > 3 ? 4.5 : label.length > 2 ? 5.5 : 6 }" font-weight="700" fill="${ color }" font-family="Arial,sans-serif" stroke="none">${ label }</text>
		</svg>`;

	const getFileIcon = ( dl ) => {
		const ext = detectFileType( dl );
		if ( dl.lang && LANG_COLORS[ dl.lang ] ) {
			const lbl = LANG_ICON_LABELS[ dl.lang ] || dl.lang;
			return DOC_SVG_WITH_LABEL( lbl, LANG_COLORS[ dl.lang ] );
		}
		const color = FILE_TYPE_COLORS[ ext ] || '#0076a1';
		return DOC_SVG_WITH_LABEL( ext.toUpperCase(), color );
	};

	/**
	 * Build download cards HTML.
	 * - `download` attribute to trigger download instead of opening in new tab.
	 * - Previewable cards (pdf, htm, html, doc, docx) get `data-preview-url`.
	 * - The best match for the page language gets `is-previewing`.
	 */
	const buildDownloadsHTML = ( downloads ) => {
		if ( ! downloads || downloads.length === 0 ) {
			return '<p class="br-pub-modal__no-dl">No downloads available for this publication.</p>';
		}

		// Pick the initial card to preview (language + type priority)
		const initialDl = pickBestPreview( downloads );

		let html = '<div class="br-pub-dl-cards">';
		downloads.forEach( dl => {
			const label = dl.lang && LANG_LABELS[ dl.lang ] ? LANG_LABELS[ dl.lang ] : ( dl.label || 'Document' );
			const icon = getFileIcon( dl );
			const ext = detectFileType( dl );
			const previewOk = canPreview( dl );
			const previewAttr = previewOk ? ` data-preview-url="${ dl.url }" data-preview-ext="${ ext }"` : '';
			const isInitial = previewOk && initialDl && dl.url === initialDl.url;
			const cls = 'br-pub-dl-card' + ( isInitial ? ' is-previewing' : '' );

			html += `<a href="${ dl.url }" download class="${ cls }"${ previewAttr }>
				<div class="br-pub-dl-card__icon">${ icon }</div>
				<span class="br-pub-dl-card__label">${ label }</span>
				<span class="br-pub-dl-card__price">Free of charge</span>
				<div class="br-pub-dl-card__dl-icon">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#0076a1" stroke-width="2"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
				</div>
			</a>`;
		} );
		html += '</div>';
		return html;
	};

	const buildEditionButtons = ( editions, container, className ) => {
		container.innerHTML = '';
		if ( ! editions || editions.length === 0 ) return false;
		editions.forEach( ed => {
			const btn = document.createElement( 'button' );
			btn.type = 'button';
			btn.className = className;
			btn.textContent = ed.year;
			btn.dataset.editionUrl = ed.url;
			container.appendChild( btn );
		} );
		return true;
	};

	const LOADING_HTML = '<div class="br-pub-modal__loading"><div class="br-pub__spinner-small"></div><span>Loading…</span></div>';

	const VIEWPORT_EMPTY_HTML = `<div class="br-pub-preview__empty">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="1.5">
			<path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/>
			<line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
		</svg>
		<span>Hover a document to preview</span>
	</div>`;

	/** Reset a preview pane to its empty state */
	const resetPreview = ( previewEl ) => {
		if ( ! previewEl ) return;
		const header   = previewEl.querySelector( '[data-preview-header]' );
		const viewport = previewEl.querySelector( '[data-preview-viewport]' );
		if ( header )   header.style.display = 'none';
		if ( viewport ) viewport.innerHTML = VIEWPORT_EMPTY_HTML;
	};

	/* ─── Preview helpers ─── */

	const ZOOM_STEPS  = [ 50, 60, 70, 80, 90, 100, 125, 150 ];
	const DEFAULT_ZOOM = 80;

	const setupPreview = ( downloadsEl, previewEl, downloads ) => {
		if ( ! previewEl ) return;

		const header    = previewEl.querySelector( '[data-preview-header]' );
		const viewport  = previewEl.querySelector( '[data-preview-viewport]' );
		const titleEl   = previewEl.querySelector( '[data-preview-title]' );
		const levelEl   = previewEl.querySelector( '[data-preview-zoom-level]' );
		const zoomOutEl = previewEl.querySelector( '[data-preview-zoom="out"]' );
		const zoomInEl  = previewEl.querySelector( '[data-preview-zoom="in"]' );
		const zoomWrap  = previewEl.querySelector( '.br-pub-preview__zoom' );

		if ( ! viewport ) return;

		let currentUrl = '';
		let currentExt = 'pdf';
		let currentLabel = '';
		let zoom = DEFAULT_ZOOM;

		const loadIframe = ( url, ext, z ) => {
			const src = buildPreviewSrc( url, ext, z );
			viewport.innerHTML = `<iframe class="br-pub-preview__iframe" src="${ src }" title="Document preview"></iframe>`;
		};

		const updateZoomLabel = () => {
			if ( levelEl ) levelEl.textContent = zoom + ' %';
		};

		const showPreview = ( url, ext, label ) => {
			const urlChanged = url !== currentUrl;
			currentUrl = url;
			currentExt = ext || 'pdf';
			currentLabel = label || currentLabel;

			// Show header + title
			if ( header ) header.style.display = '';
			if ( titleEl ) titleEl.textContent = currentLabel + ' — preview';

			// Show/hide zoom controls (only useful for PDF)
			if ( zoomWrap ) zoomWrap.style.display = currentExt === 'pdf' ? '' : 'none';

			if ( urlChanged ) {
				zoom = DEFAULT_ZOOM;
				updateZoomLabel();
				loadIframe( url, currentExt, zoom );
			}
		};

		// Zoom controls (PDF only)
		const changeZoom = ( dir ) => {
			if ( currentExt !== 'pdf' ) return;
			const idx = ZOOM_STEPS.indexOf( zoom );
			let next;
			if ( dir === 'in' )  next = idx < ZOOM_STEPS.length - 1 ? ZOOM_STEPS[ idx + 1 ] : zoom;
			else                  next = idx > 0 ? ZOOM_STEPS[ idx - 1 ] : zoom;
			if ( next === zoom ) return;
			zoom = next;
			updateZoomLabel();
			if ( currentUrl ) loadIframe( currentUrl, currentExt, zoom );
		};

		if ( zoomOutEl ) zoomOutEl.addEventListener( 'click', ( e ) => { e.preventDefault(); e.stopPropagation(); changeZoom( 'out' ); } );
		if ( zoomInEl )  zoomInEl.addEventListener( 'click', ( e ) => { e.preventDefault(); e.stopPropagation(); changeZoom( 'in' ); } );

		// Auto-preview: best match (language + type priority: PDF → DOCX → HTM)
		const initialDl = pickBestPreview( downloads );

		if ( initialDl ) {
			const lbl = initialDl.lang && LANG_LABELS[ initialDl.lang ] ? LANG_LABELS[ initialDl.lang ] : ( initialDl.label || 'Document' );
			showPreview( initialDl.url, detectFileType( initialDl ), lbl );
		}

		// Hover on download cards → switch preview + highlight active card
		downloadsEl.querySelectorAll( '[data-preview-url]' ).forEach( card => {
			card.addEventListener( 'mouseenter', () => {
				downloadsEl.querySelectorAll( '.br-pub-dl-card' ).forEach( c => c.classList.remove( 'is-previewing' ) );
				card.classList.add( 'is-previewing' );
				const lbl = card.querySelector( '.br-pub-dl-card__label' );
				showPreview( card.dataset.previewUrl, card.dataset.previewExt || 'pdf', lbl ? lbl.textContent : '' );
			} );
		} );
	};

	/* ═══════════════════════════════════════
	   MODAL
	   ═══════════════════════════════════════ */

	let mTitle, mYear, mDesc, mCover, mDownloads, mPreview, mEditions, mEdList;

	if ( modal ) {
		mTitle     = modal.querySelector( '[data-modal-title]' );
		mYear      = modal.querySelector( '[data-modal-year]' );
		mDesc      = modal.querySelector( '[data-modal-desc]' );
		mCover     = modal.querySelector( '[data-modal-cover]' );
		mDownloads = modal.querySelector( '[data-modal-downloads]' );
		mPreview   = modal.querySelector( '[data-modal-preview]' );
		mEditions  = modal.querySelector( '[data-modal-editions]' );
		mEdList    = modal.querySelector( '[data-modal-editions-list]' );
	}

	const openModal = ( data ) => {
		if ( ! modal ) return;
		mTitle.textContent = data.title;
		mYear.textContent  = data.date ? data.date.substring( 0, 4 ) : '—';
		mDesc.textContent  = data.desc || '';
		mCover.innerHTML   = '<div class="br-pub-modal__cover-placeholder"></div>';
		mDownloads.innerHTML = LOADING_HTML;
		if ( mPreview ) resetPreview( mPreview );
		mEditions.style.display = 'none';
		mEdList.innerHTML = '';

		modal.setAttribute( 'aria-hidden', 'false' );
		document.body.style.overflow = 'hidden';
		requestAnimationFrame( () => modal.classList.add( 'is-open' ) );

		fetchDetail( data.link )
			.then( detail => {
				if ( detail.cover ) mCover.innerHTML = `<img src="${ detail.cover }" alt="${ data.title }" />`;
				mDownloads.innerHTML = buildDownloadsHTML( detail.downloads );
				setupPreview( mDownloads, mPreview, detail.downloads );
				if ( buildEditionButtons( detail.editions, mEdList, 'br-pub-modal__edition-btn' ) ) {
					mEditions.style.display = 'flex';
				}
			} )
			.catch( () => {
				mDownloads.innerHTML = '<p class="br-pub-modal__no-dl">Could not load publication details.</p>';
				if ( mPreview ) resetPreview( mPreview );
			} );
	};

	const closeModal = () => {
		if ( ! modal ) return;
		modal.classList.remove( 'is-open' );
		document.body.style.overflow = '';
		setTimeout( () => modal.setAttribute( 'aria-hidden', 'true' ), 300 );
	};

	if ( modal ) {
		mEdList.addEventListener( 'click', ( e ) => {
			const btn = e.target.closest( '[data-edition-url]' ); if ( ! btn ) return;
			openModal( { title: mTitle.textContent, desc: '', link: btn.dataset.editionUrl, date: btn.textContent, sector: '', type: '' } );
		} );

		modal.querySelectorAll( '[data-br-pub-modal-close]' ).forEach( el => el.addEventListener( 'click', closeModal ) );
		document.addEventListener( 'keydown', ( e ) => { if ( e.key === 'Escape' && modal.classList.contains( 'is-open' ) ) closeModal(); } );
	}

	/* ═══════════════════════════════════════
	   SUBPAGE
	   ═══════════════════════════════════════ */

	let spTitle, spHeading, spYear, spSector, spType, spDesc, spCover, spDownloads, spPreview, spEditions, spEdList, spBack;

	if ( subpage ) {
		spTitle     = subpage.querySelector( '[data-subpage-title]' );
		spHeading   = subpage.querySelector( '[data-subpage-heading]' );
		spYear      = subpage.querySelector( '[data-subpage-year]' );
		spSector    = subpage.querySelector( '[data-subpage-sector]' );
		spType      = subpage.querySelector( '[data-subpage-type]' );
		spDesc      = subpage.querySelector( '[data-subpage-desc]' );
		spCover     = subpage.querySelector( '[data-subpage-cover]' );
		spDownloads = subpage.querySelector( '[data-subpage-downloads]' );
		spPreview   = subpage.querySelector( '[data-subpage-preview]' );
		spEditions  = subpage.querySelector( '[data-subpage-editions]' );
		spEdList    = subpage.querySelector( '[data-subpage-editions-list]' );
		spBack      = subpage.querySelector( '[data-br-pub-subpage-back]' );
	}

	let subpageOpenedByPopstate = false;

	const openSubpage = ( data, { pushHistory = true } = {} ) => {
		if ( ! subpage ) return;

		spTitle.textContent   = data.title;
		spHeading.textContent = data.title;
		spYear.textContent    = data.date ? data.date.substring( 0, 4 ) : '';
		spSector.textContent  = data.sector || '';
		spType.textContent    = data.type || '';
		spDesc.textContent    = data.desc || '';
		spCover.innerHTML     = '<div class="br-pub-modal__cover-placeholder"></div>';
		spDownloads.innerHTML = LOADING_HTML;
		if ( spPreview ) resetPreview( spPreview );
		spEditions.style.display = 'none';
		if ( spEdList ) spEdList.innerHTML = '';

		listingEls().forEach( el => el.style.display = 'none' );
		subpage.style.display = '';
		block.classList.add( 'br-pub--subpage-open' );

		if ( pushHistory && data.link ) {
			const url = new URL( window.location );
			url.searchParams.set( 'pub', data.link );
			history.pushState( { brPubDetail: true, data }, '', url );
		}

		block.scrollIntoView( { behavior: 'smooth', block: 'start' } );

		fetchDetail( data.link )
			.then( detail => {
				if ( detail.cover ) spCover.innerHTML = `<img src="${ detail.cover }" alt="${ data.title }" />`;
				spDownloads.innerHTML = buildDownloadsHTML( detail.downloads );
				setupPreview( spDownloads, spPreview, detail.downloads );
				if ( spEdList && buildEditionButtons( detail.editions, spEdList, 'br-pub-modal__edition-btn' ) ) {
					spEditions.style.display = 'flex';
				}
			} )
			.catch( () => {
				spDownloads.innerHTML = '<p class="br-pub-modal__no-dl">Could not load publication details.</p>';
				if ( spPreview ) resetPreview( spPreview );
			} );
	};

	const closeSubpage = ( { updateUrl = true } = {} ) => {
		if ( ! subpage ) return;
		subpage.style.display = 'none';
		block.classList.remove( 'br-pub--subpage-open' );
		listingEls().forEach( el => el.style.display = '' );

		const tableWrap = block.querySelector( '[data-br-pub-content="table"]' );
		const cardsWrap = block.querySelector( '[data-br-pub-content="cards"]' );
		const listWrap  = block.querySelector( '[data-br-pub-content="list"]' );
		if ( tableWrap ) tableWrap.style.display = currentLayout === 'table' ? '' : 'none';
		if ( cardsWrap ) cardsWrap.style.display = currentLayout === 'cards' ? '' : 'none';
		if ( listWrap  ) listWrap.style.display  = currentLayout === 'list'  ? '' : 'none';
		if ( currentLayout === 'list' ) renderListPagination();

		if ( updateUrl ) {
			const url = new URL( window.location );
			url.searchParams.delete( 'pub' );
			history.pushState( null, '', url );
		}

		applyFilters();
	};

	if ( subpage ) {
		if ( spBack ) spBack.addEventListener( 'click', () => {
			history.back();
		} );

		window.addEventListener( 'popstate', ( e ) => {
			if ( e.state && e.state.brPubDetail ) {
				openSubpage( e.state.data, { pushHistory: false } );
			} else if ( block.classList.contains( 'br-pub--subpage-open' ) ) {
				closeSubpage( { updateUrl: false } );
			}
		} );

		const initUrl = new URL( window.location );
		const initPub = initUrl.searchParams.get( 'pub' );
		if ( initPub ) {
			const match = block.querySelector( `[data-pub-link="${ CSS.escape( initPub ) }"]` )
				|| block.querySelector( `[data-pub-link="${ initPub }"]` );

			const data = match
				? {
					title:  match.dataset.pubTitle,
					desc:   match.dataset.pubDesc,
					link:   match.dataset.pubLink,
					date:   match.dataset.pubDate,
					sector: match.dataset.pubSector,
					type:   match.dataset.pubType,
				}
				: {
					title:  initUrl.searchParams.get( 'pub_title' )  || '',
					desc:   initUrl.searchParams.get( 'pub_desc' )   || '',
					link:   initPub,
					date:   initUrl.searchParams.get( 'pub_date' )   || '',
					sector: initUrl.searchParams.get( 'pub_sector' ) || '',
					type:   initUrl.searchParams.get( 'pub_type' )   || '',
				};

			if ( data.title || data.link ) {
				openSubpage( data, { pushHistory: false } );
				history.replaceState( { brPubDetail: true, data }, '', window.location );
			}
		}

		if ( spEdList ) {
			spEdList.addEventListener( 'click', ( e ) => {
				const btn = e.target.closest( '[data-edition-url]' ); if ( ! btn ) return;
				openSubpage( { title: spHeading.textContent, desc: '', link: btn.dataset.editionUrl, date: btn.textContent, sector: '', type: '' } );
			} );
		}
	}

	/* ═══════════════════════════════════════
	   CLICK HANDLER – route to modal or subpage
	   ═══════════════════════════════════════ */

	block.addEventListener( 'click', ( e ) => {
		if ( e.target.closest( '[data-br-pub-modal]' ) ) return;
		if ( e.target.closest( '[data-br-pub-subpage]' ) ) return;

		const item = e.target.closest( '[data-pub-title]' ); if ( ! item ) return;
		e.preventDefault();

		const data = {
			title:  item.dataset.pubTitle,
			desc:   item.dataset.pubDesc,
			link:   item.dataset.pubLink,
			date:   item.dataset.pubDate,
			sector: item.dataset.pubSector,
			type:   item.dataset.pubType,
		};

		if ( detailView === 'modal' ) {
			openModal( data );
		} else {
			openSubpage( data );
		}
	} );
} );